import { IDomesticTourismOffer } from "web/types/Tourism";

const isGds = (source: IDomesticTourismOffer["source"]) =>
  source !== "MYBENEFIT";

export default isGds;
